module.exports = __webpack_public_path__ + "assets/img/season-code-02-064c6a62.png";